import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./components/Home/Home";
import Profile from "./components/Profile/Profile";
import Projects from "./components/Projects/Projects";
import ProjectDetail from "./components/Projects/ProjectDetail";
import Resume from "./components/Resume/ResumeNew";
import ScrollToTop from "./components/ScrollToTop";
import "bootstrap/dist/css/bootstrap.min.css";
import "./style.css";
import "./App.css";

const getRequestedLanguage = (search) => {
  const language = new URLSearchParams(search).get("lang");
  return language === "zh" || language === "en" ? language : null;
};

function AppContent() {
  const location = useLocation();
  const navigate = useNavigate();
  const [language, setLanguage] = useState(
    () =>
      getRequestedLanguage(window.location.search) ||
      window.localStorage.getItem("eunice-language") ||
      "zh"
  );

  useEffect(() => {
    window.localStorage.setItem("eunice-language", language);
    document.documentElement.lang = language === "zh" ? "zh-HK" : "en";
  }, [language]);

  useEffect(() => {
    const requestedLanguage = getRequestedLanguage(location.search);

    if (requestedLanguage && requestedLanguage !== language) {
      setLanguage(requestedLanguage);
      return;
    }

    if (!requestedLanguage) {
      const searchParams = new URLSearchParams(location.search);
      searchParams.set("lang", language);
      navigate(
        {
          pathname: location.pathname,
          search: searchParams.toString(),
          hash: location.hash,
        },
        { replace: true }
      );
    }
  }, [language, location.hash, location.pathname, location.search, navigate]);

  const toggleLanguage = () => {
    const nextLanguage = language === "zh" ? "en" : "zh";
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("lang", nextLanguage);
    setLanguage(nextLanguage);
    navigate(
      {
        pathname: location.pathname,
        search: searchParams.toString(),
        hash: location.hash,
      },
      { replace: true }
    );
  };

  return (
    <div className="App">
      <Navbar language={language} onToggleLanguage={toggleLanguage} />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home language={language} />} />
        <Route path="/profile" element={<Profile language={language} />} />
        <Route path="/project" element={<Projects language={language} />} />
        <Route path="/project/:slug" element={<ProjectDetail language={language} />} />
        <Route path="/resume" element={<Resume language={language} />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
